import { LitElement, html, css } from 'lit'

class MenuButton extends LitElement {
  static styles = css`
    :host {
      display: flex;
      position: relative;
    }
    :host([aria-expanded='true']) .line:before {
      transform: rotate(45deg);
      top: auto;
      border-radius: 1px;
    }
    :host([aria-expanded='true']) .line:after {
      transform: rotate(-45deg);
      bottom: auto;
      border-radius: 1px;
    }
    :host([aria-expanded='true']) .line {
      height: 0;
    }
    :host([aria-expanded='true']) .label.open {
      display: none;
    }
    :host([aria-expanded='false']) .label.close {
      display: none;
    }
    button {
      appearance: none;
      padding: 0;
      border: none;
      background: transparent;
      width: 100%;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 0.5em;
      position: relative;
      right: -0.5em;
      transition: background 150ms ease-in-out;
      color: hsl(var(--text-color-dark));
    }
    button:focus-visible {
      outline: var(--outline);
      outline-offset: 0;
      outline-color: var(--focus-color);
      border-radius: 4px;
    }
    button:hover {
      background: hsl(var(--gray-40));
      border-radius: 4px;
    }
    .icon {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 2rem;
      width: 2rem;
      position: relative;
    }
    .line {
      display: block;
      background: hsl(var(--text-color-dark));
      height: 2px;
      width: 14px;
      margin: 0 4px;
      transition: width 100ms ease-in-out;
    }
    .line:before,
    .line:after {
      content: '';
      width: auto;
      display: block;
      background: hsl(var(--text-color-dark));
      height: 2px;
      position: absolute;
      right: 4px;
      left: 4px;
    }
    .line:before {
      top: 7px;
    }
    .line:after {
      bottom: 7px;
    }
    .label {
      font-size: var(--xs);
      font-family: var(--base-font);
      position: relative;
    }
    button:hover .line {
      width: 100%;
    }
  `

  constructor() {
    super()
  }

  render() {
    return html`
      <button>
        <span class="icon">
          <span class="line"></span>
        </span>
        <span class="label open">Meny</span>
        <span class="label close">Stäng</span>
      </button>
    `
  }
}
customElements.define('menu-button', MenuButton)
